import { START_BET, ASK_QUESTION } from '../questions/actions'
import {QUESTION_ASKED, BET_STARTED} from '../questionGame/actions'
import {BET_PLACED} from '../userAnswer/actions'
export const CURRENTQUESTIONID_RECEIVED = 'CURRENTQUESTIONID_RECEIVED'



export const currentQuestionId = (state = null, action) => {
    switch (action.type) {
        case CURRENTQUESTIONID_RECEIVED:
            return action.currentQuestionId

        case START_BET:
        case BET_STARTED:
        case ASK_QUESTION:
        case QUESTION_ASKED:
            return action.question.id

        case BET_PLACED:
            return action.question_id

        default:
            return state
    }
}

export const receiveCurrentQuestionId = (currentQuestionId) => {
    return { type: CURRENTQUESTIONID_RECEIVED, currentQuestionId }
}


// WEBPACK FOOTER //
// ./src/reducers/currentQuestionId/index.js